import type {LeadList} from "../../../types/leads.types";

import {deleteLead} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../lead-keys";

export function deleteLeadMutationOptions() {
  const listFilter = {queryKey: leadKeys.lists()};

  return mutationOptions({
    mutationFn: (id: string) => deleteLead(id),
    mutationKey: leadMutationKeys.deleteLead,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<LeadList>(listFilter);

      client.setQueriesData<LeadList>(listFilter, (old) => {
        if (!old) return old;

        return {
          ...old,
          items: old.items.filter((lead) => lead.leadId !== deletedId),
          meta: {...old.meta, total: Math.max(0, old.meta.total - 1)},
        };
      });

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      context?.previousLists.forEach(([key, snapshot]) => client.setQueryData(key, snapshot));
    },
    onSuccess: async (_data, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: leadKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
